import { MaterialReactTable } from "material-react-table"
import { Card, CardBody, Row } from "reactstrap"
import { attributeColumnData } from "./constants/ListingCustomerFunctions"

export const AttributeTableInView = ({ attributeData }) => {
  const column = attributeColumnData()
  return (

    <div className="border rounded-1 px-0 py-3 my-3 bg-white h-100">
          {attributeData?.length>0 ? <MaterialReactTable
            columns={column}
            data={attributeData}
            muiTablePaperProps={{
              elevation: 0,
            }}
            defaultColumn={{
              minSize: 10,
              maxSize: 9001,
              muiTableBodyCellProps: {
                sx: {
                  fontFamily: "Inter,sans-serif"
                }
              },
              muiTableHeadCellProps: {
                sx: {
                  fontFamily: "Inter,sans-serif"
                }
              }
            }}
            enableBottomToolbar={false}
            enableColumnActions={true}
            enableDensityToggle={false}
            enablePagination={false}
            renderTopToolbar={false}
          />: (
            <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '200px' }}>
                No record to display
            </div>
        )}
    </div>
  )
}